// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 删除文章
 * @param id
 * @constructor
 */
export function DelArticle(id) {
  return request({
    url: "/admin/platform/article/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 文章详情
 * @param id
 * @constructor
 */
export function InfoArticle(id) {
  return request({
    url: "/admin/platform/article/info/".concat(id),
    method: 'get'
  });
}

/**
 * 文章列表
 * @param pram
 * @constructor
 */
export function ListArticle(pram) {
  var data = {
    author: pram.author,
    cid: pram.cid,
    page: pram.page,
    limit: pram.limit,
    title: pram.title,
    status: pram.status,
    plateId: pram.plateId,
    limitTempId: pram.limitTempId,
    dateLimit: pram.dateLimit
  };
  return request({
    url: '/admin/platform/article/list',
    method: 'GET',
    params: data
  });
}

/**
 * 新增文章
 * @param data
 * @constructor
 */
export function AddArticle(data) {
  return request({
    url: '/admin/platform/article/save',
    method: 'post',
    data: data
  });
}

/**
 * 更新文章
 * @param data
 * @constructor
 */
export function UpdateArticle(data) {
  return request({
    url: '/admin/platform/article/update',
    method: 'post',
    data: data
  });
}

/**
 * 新增文章分类
 * @param data
 * @constructor
 */
export function articleCategoryAddApi(data) {
  return request({
    url: '/admin/platform/article/category/add',
    method: 'POST',
    data: data
  });
}

/**
 * 删除文章分类
 * @param data
 * @constructor
 */
export function articleCategoryDelApi(row) {
  return request({
    url: "admin/platform/article/category/delete/".concat(row.id),
    method: 'POST'
  });
}

/**
 * 文章分类分页列表
 * @constructor
 */
export function articleCategoryListApi(params) {
  return request({
    url: "admin/platform/article/category/list",
    method: 'GET',
    params: params
  });
}

/**
 * 修改文章分类
 * @param data
 * @constructor
 */
export function articleCategoryUpdateApi(data) {
  return request({
    url: "admin/platform/article/category/update",
    method: 'POST',
    data: data
  });
}

/**
 * 文章开关
 * @param data
 */
export function articleSwitchApi(id) {
  return request({
    url: "/admin/platform/article/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 文章分类开关
 * @param data
 */
export function articleCategorySwitchApi(id) {
  return request({
    url: "/admin/platform/article/category/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 系统消息分页列表
 * @constructor
 */
export function adminagentmessagepage(params) {
  return request({
    url: "/admin/agent/message/page",
    method: 'GET',
    params: params
  });
}

/**
 * 系统消息分页列表启用状态更新
 * @constructor
 */
export function adminagentmessageswitch(params) {
  return request({
    url: "/admin/agent/message/switch",
    method: 'GET',
    params: params
  });
}

/**
 * 系统消息列表详情
 * @param id
 * @constructor
 */
export function adminagentmessagedetail(params) {
  return request({
    url: "/admin/agent/message/detail",
    method: 'get',
    params: params
  });
}

/**
 * 编辑系统消息
 * @param data
 * @constructor
 */
export function adminagentmessageupdate(data) {
  return request({
    url: "/admin/agent/message/update",
    method: 'POST',
    data: data
  });
}

/**
 * 新增系统消息
 * @param data
 * @constructor
 */
export function adminagentmessageadd(data) {
  return request({
    url: "/admin/agent/message/add",
    method: 'POST',
    data: data
  });
}

/**
 * 删除系统消息
 * @param params
 * @constructor
 */
export function adminagentmessagedelete(params) {
  return request({
    url: "/admin/agent/message/delete",
    method: 'GET',
    params: params
  });
}

/**
 * 文章板块下拉项
 * @param params
 * @constructor
 */
export function adminplatformarticleplatelist(params) {
  return request({
    url: "/admin/platform/article/plate/list",
    method: 'GET',
    params: params
  });
}
/**
 * 新增文章板块名称
 * @param data
 * @constructor
 */
export function adminplatformarticleplateadd(data) {
  return request({
    url: '/admin/platform/article/plate/add',
    method: 'POST',
    data: data
  });
}
/**
 * 删除文章板块名称
 * @param data
 * @constructor
 */
export function adminplatformarticleplatedelete(data) {
  return request({
    url: "/admin/platform/article/plate/delete/".concat(data),
    method: 'POST'
  });
}